module.exports = __webpack_public_path__ + "static/img/friends-invitation-btn.5355f84.png";